export const isArrayEmpty = array =>
  Array.isArray(array) && array.length === 0;
